import Vector2 from "./Vector2";
import Rect from "./Rect";

export default class Camera {
  private _position: Vector2;
  private _scale: number;

  public get position(): Vector2 {
    return this._position;
  }

  public get scale(): number {
    return this._scale;
  }

  public transformPointWorldToScreen(vec: Vector2): Vector2 {
    var offsetFromOrigin = vec.sub(this._position);
    return offsetFromOrigin.mulScalar(this._scale);
  }

  public transformRectWorldToScreen(rect: Rect): Rect {
    return Rect.fromExtents(
      this.transformPointWorldToScreen(rect.position),
      this.transformPointWorldToScreen(rect.getEndPoint())
    );
  }

  public transformPointScreenToWorld(vec: Vector2): Vector2 {
    var offsetFromOrigin = vec.divScalar(this._scale);
    return offsetFromOrigin.add(this._position);
  }

  public transformRectScreenToWorld(rect: Rect): Rect {
    return Rect.fromExtents(
      this.transformPointScreenToWorld(rect.position),
      this.transformPointScreenToWorld(rect.getEndPoint())
    );
  }

  public constructor(position = new Vector2(), scale = 1) {
    this._position = position;
    this._scale = scale;
  }
}
